import EUDDFields from './EUDDFields'

export default EUDDFields
